import React from "react";
import styled from "styled-components";

import sortIconAsc from "../../../images/sort-icon-asc.svg";
import sortIconDesc from "../../../images/sort-icon-desc.svg";

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Arrow = styled.img`
    width: 8px;
`;

const SortArrow = ({dir}) => {
    const imgClassName = `t-sort-${dir}`;
    return <Container className="t-sort-arrow">
        <Arrow className={imgClassName}
               src={dir === "ASC" ? sortIconAsc : sortIconDesc}/>
    </Container>;
};

export default SortArrow;